module.exports = __webpack_public_path__ + "static/media/LoginPageView.design@mobile.b749593d.png";